import { Component, ElementRef, Inject, Input, NgZone, PLATFORM_ID, TransferState } from '@angular/core';

import {
  DxResizableModule,
  DxSplitterComponent,
  DxTemplateHost,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';

@Component({
  selector: 'abc-spl',
  template: '',
  standalone: true,
  providers: [DxTemplateHost, WatcherHelper, IterableDifferHelper, NestedOptionHost, DxResizableModule],
})
export class AbcSplitterV2Component extends DxSplitterComponent {
  public elementRef: ElementRef;
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    _idh: IterableDifferHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, _idh, optionHost, transferState, platformId);
    this.elementRef = elementRef;
  }
}
